<template>
  <div class="mt-5">
    <div id="ticket-total" class="flex items-baseline justify-between">
      <span id="ticket-total-label">Tickets</span>
      <OnClickOutside class="relative" @trigger="isCouponMenuOpen = false">
        <span
          id="ticket-total-value"
          :class="{ 'cursor-pointer text-fg-link-primary': coupons.length > 0 }"
          @click="isCouponMenuOpen = !isCouponMenuOpen"
        >
          {{ settingStore.currency(pricing.amount) }}
        </span>
        <div
          id="coupon-list"
          v-if="coupons.length > 0"
          v-show="isCouponMenuOpen"
          class="absolute right-0 top-6 bg-surface-primary rounded-md px-4 py-2.5 shadow-lg border border-linear-subtle w-24 flex flex-col items-end justify-start gap-2"
        >
          <LabelDefault>Discount</LabelDefault>
          <div
            :id="`coupon-item-${coupon.id}`"
            v-for="coupon in coupons"
            :key="coupon.id"
            :class="
              coupon.id === selectedCoupon.id
                ? 'text-fg-primary font-semibold'
                : 'text-fg-link-primary'
            "
            class="coupon-item cursor-pointer tabular-nums w-full text-right"
            @click="setSelectedCoupon(coupon)"
          >
            {{ coupon.percent_off }}%
          </div>
        </div>
      </OnClickOutside>
    </div>
    <div id="service-fee" class="flex items-baseline justify-between">
      <span id="service-fee-label">Service Fee</span>
      <span id="service-fee-value">
        {{ settingStore.currency(pricing.serviceFee) }}
      </span>
    </div>
    <div id="tax" class="flex items-baseline justify-between">
      <span id="tax-label">Tax</span>
      <span id="tax-value">
        {{ settingStore.currency(pricing.tax) }}
      </span>
    </div>
    <div id="total" class="flex items-baseline justify-between text-lg font-semibold">
      <span id="total-label">Total</span>
      <span id="total-value">
        {{ settingStore.currency(pricing.total) }}
      </span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { OnClickOutside } from '@vueuse/components'
import { ref } from 'vue'

import LabelDefault from '@/common/components/atoms/LabelDefault.vue'
import { OrderPricing } from '@/orders'
import { useSettingStore } from '@/stores/setting'

import { CouponRead } from '@generated/types'

const emit = defineEmits<{
  // eslint-disable-next-line no-unused-vars
  (e: 'update:selectedCoupon', coupon: CouponRead): void
}>()

defineProps<{
  pricing: OrderPricing
  coupons: CouponRead[]
  selectedCoupon: CouponRead
}>()

const settingStore = useSettingStore()

const isCouponMenuOpen = ref(false)
function setSelectedCoupon(coupon: CouponRead) {
  emit('update:selectedCoupon', coupon)
  isCouponMenuOpen.value = false
}
</script>
